import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { signup } from '../actions/user'
import SignupForm from '../components/signup/form'
import validate from '../components/signup/validation'
import { getWebAuth } from '../lib/auth'
import { capturePostHogEvent, capturePostHogPageview } from '../lib/posthog'

class Signup extends Component {
  constructor(props) {
    super(props)

    this.handleSignup = this.handleSignup.bind(this)
    this.handleLoginClick = this.handleLoginClick.bind(this)
    this.state = { error: null, success: false }
  }

  componentDidMount() {
    capturePostHogPageview('/signup')

    // If user is already authenticated, redirect to home
    const token = window.localStorage.getItem('token')
    const expiresAt = parseInt(window.localStorage.getItem('expires_at'))
    if (token && new Date().getTime() < expiresAt) {
      this.props.history.push('/')
    }
  }

  handleLoginClick() {
    const webAuth = getWebAuth(window.location.origin)
    webAuth.authorize()
  }

  handleSignup(data) {
    validate(data)

    const params = {
      email: data.realEmail,
      password: data.password,
      first_name: data.firstName,
      last_name: data.lastName,
      gender: data.gender,
      age: Number(data.age),
      units: data.units,
      turnstileToken: data.turnstileToken || '',
    }

    capturePostHogEvent('signup_attempted', {
      has_turnstile_token: Boolean(params.turnstileToken),
      gender: params.gender,
      units: params.units,
      age: params.age,
    })

    this.props.signup(params).then((response) => {
      if (response && response.payload) {
        if (response.payload.status === 200) {
          capturePostHogEvent('signup_succeeded', {
            email_domain: params.email.split('@')[1] || null,
          })
          this.setState({ success: true, error: null })
        } else if (response.payload.response) {
          const { status, data: responseData } = response.payload.response
          const message =
            responseData && typeof responseData === 'string'
              ? responseData
              : null
          capturePostHogEvent('signup_failed', {
            status,
            error: message || 'unknown',
          })
          if (status === 409) {
            this.setState({
              error:
                'E-mail already exists, please try again with another e-mail',
            })
          } else if (status === 403) {
            this.setState({
              error: message || 'Signup is not available. Please try again.',
            })
          } else if (status === 429) {
            this.setState({
              error:
                'Too many signup attempts. Please try again in a few minutes.',
            })
          } else if (status === 400 || status === 422) {
            this.setState({
              error: message || 'Please check your information and try again.',
            })
          } else {
            this.setState({
              error: 'Error signing up. Please try again or contact support.',
            })
          }
        } else {
          this.setState({
            error: 'Error signing up. Please try again or contact support.',
          })
        }
      }
    })
  }

  render() {
    return (
      <SignupForm
        {...this.props}
        onSignup={this.handleSignup}
        errorMessage={this.state.error}
        successMessage={this.state.success}
        onLoginClick={this.handleLoginClick}
      />
    )
  }
}

Signup.propTypes = {
  signup: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
}

const mapStateToProps = (state) => ({
  width: state.windowDimensions.width,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ signup }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Signup)
